import React from 'react'
import css from './index.css'
export const IconCheck = () => {
  return (
    <div className={css.iconCheck}></div>
  )
}

export const IconLinked  = () => {
  return (
    <div className={css.iconLinked}></div>
  )
}
export const IconUnlinked  =  () => {
  return (
    <div className={css.iconUnlinked}></div>
  )
}
export const IconLinkpending  =  () => {
  return (
    <div className={css.iconLinkpending}></div>
  )
}


// WEBPACK FOOTER //
// ./src/components/pages/MyAccount/share/AccountIcon/index.js